const DEFAULT_SNACKBAR_MESSAGE = 'Oops, something went wrong :(';
const DEFAULT_SNACKBAR_COLOR = 'red';

const moduleMain = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    snackbar: {
      isSnackbar: false,
      text: DEFAULT_SNACKBAR_MESSAGE,
      color: DEFAULT_SNACKBAR_COLOR,
      timerId: null
    },
    isMobileSidebar: false
  }),
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    isSnackbar(state) {
      return state.snackbar.isSnackbar;
    },
    snackbar(state) {
      return state.snackbar;
    },
    isMobileSidebar(state) {
      return state.isMobileSidebar;
    }
  },
  mutations: {
    updateLoading(state, data) {
      state.isLoading = data;
    },
    updateSnackbar(state, data) {
      state.snackbar.isSnackbar = data.isSnackbar;
      if ('text' in data) state.snackbar.text = data.text;
      if ('color' in data) state.snackbar.color = data.color;
      if ('timerId' in data) state.snackbar.timerId = data.timerId;
    },
    updateMobileSidebar(state, data) {
      state.isMobileSidebar = data;
    }
  },
  actions: {
    async startLoading({ commit }) {
      commit('updateLoading', true);
    },
    async stopLoading({ commit }) {
      commit('updateLoading', false);
    },
    async showSnackbar({ commit, state }, { text = DEFAULT_SNACKBAR_MESSAGE, color = DEFAULT_SNACKBAR_COLOR } = {}) {
      // A previous timer would otherwise close the new message too early
      if (state.snackbar.timerId) clearTimeout(state.snackbar.timerId);
      const timerId = setTimeout(() => {
        commit('updateSnackbar', { isSnackbar: false, timerId: null });
      }, 5000);
      commit('updateSnackbar', { text, color, isSnackbar: true, timerId });
    },
    async hideSnackbar({ commit, state }) {
      if (state.snackbar.timerId) clearTimeout(state.snackbar.timerId);
      commit('updateSnackbar', { isSnackbar: false, timerId: null });
    },
    // if the desktop version, call the action without parameters
    // and isMobileSidebar is set to true => the sidebar is visible
    async toggleMobileSidebar({ commit }, isSidebarShown = false) {
      commit('updateMobileSidebar', !isSidebarShown);
    }
  }
};

export default moduleMain;
